import {
  AIWorkflowConfig,
  WorkflowStep,
  DecisionNode,
  ActionStepData,
  GroupedActions,
} from '../../types';
import {
  ApiAction,
  CreateWorkflowRequest,
  WorkflowStepRequest,
} from 'api/types/aiWorkflowTypes';
import { ACTION_TYPES } from '../../constants';

export const createEmptyWorkflow = (): AIWorkflowConfig => ({
  name: 'Untitled flow',
  description: '',
  isEnabled: true,
  triggerCode: null,
  triggerScope: 'all_users',
  employeeList: [],
  employeeNames: [],
  trigger: null,
  decision: null,
  actions: [],
});

export const groupActions = (actions: ApiAction[]): GroupedActions => {
  return actions.reduce((acc, action) => {
    const group = action.group || 'Other';
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(action);
    return acc;
  }, {} as GroupedActions);
};

export const convertToApiRequest = (workflow: AIWorkflowConfig): CreateWorkflowRequest => {
  const steps: WorkflowStepRequest[] = [];

  if (workflow.decision) {
    const decisionData = workflow.decision.data as DecisionNode;
    if (decisionData.prompt) {
      steps.push({
        action_type: ACTION_TYPES.AI_DECISION,
        action: 'AI Decision',
        configuration: {
          userWorkflowDecisionPrompt: decisionData.prompt,
        },
      });
    }
  }

  workflow.actions.forEach((actionStep) => {
    const actionData = actionStep.data as ActionStepData;
    steps.push({
      action_type: actionData.code,
      action: actionData.name,
      configuration: actionData.config || {},
    });
  });

  return {
    name: workflow.name || 'Untitled flow',
    trigger: workflow.triggerCode || '',
    trigger_scope: workflow.triggerScope,
    employee_list: workflow.employeeList,
    employee_names: workflow.employeeNames,
    steps,
    is_active: workflow.isEnabled,
  };
};
